import type { ProductListConfigStyles } from '../product-list/_propsFn'
import { normalizeFacetValueIds, parseDataAttributes } from '../../utilities/utilities'

export interface RelatedProductsAttributes {
  facetIds?: string[]
  itemsPerView: number
  take: number
  showRelatedProducts: boolean
  showCta?: boolean
  showProgressBar?: boolean
  showInStock?: boolean
  showPrice?: boolean
  configStyles?: ProductListConfigStyles
}

function isProductListConfigStyles(value: unknown): value is ProductListConfigStyles {
  return typeof value === 'object' && value !== null
}

/**
 * Normalize related products widget data attributes into typed React props.
 */
export function getRelatedProductsAttributes(attrs: NamedNodeMap): RelatedProductsAttributes {
  const base = parseDataAttributes(attrs)

  const facetIds = normalizeFacetValueIds(base.facetValueIds)
  const itemsPerView = typeof base.itemsPerView === 'number' ? base.itemsPerView : 4
  const take = typeof base.take === 'number' ? base.take : 8
  const showRelatedProducts =
    base.showRelatedProducts === 'yes' || base.showRelatedProducts === true
  const showCta = base.showCta === 'yes' || base.showCta === true
  const showProgressBar = base.showProgressBar === 'yes' || base.showProgressBar === true
  const showInStock = base.showInStock === 'yes' || base.showInStock === true
  const showPrice = base.showPrice === 'yes' || base.showPrice === true

  return {
    facetIds,
    itemsPerView,
    take,
    showRelatedProducts,
    showCta,
    showProgressBar,
    showInStock,
    showPrice,
    configStyles: isProductListConfigStyles(base.configStyles) ? base.configStyles : undefined,
  }
}

/**
 * Parse DOM data attributes for the related products widget entry point.
 */
export default function propsFn(dataAttributes: NamedNodeMap): RelatedProductsAttributes {
  return getRelatedProductsAttributes(dataAttributes)
}
